import axios from "axios";
import $ from "jquery";
import {
  ASSIGN_USER_TO_PROJECT,
  GET_USERS_ASSIGNED_TO_PROJECT,
  USER_LIST_URLS,
} from "@/utils/constants/constants.js";

function parse_response_data(response_data) {
  return typeof response_data === "string" ? JSON.parse(response_data) : response_data;
}

export default {
  methods: {
    async select_project(project_id) {
      this.assigned_users = [];
      this.project_id = project_id;
      const response = await axios.post(GET_USERS_ASSIGNED_TO_PROJECT, { project_id: this.project_id }, { headers: this.headers });
      this.assigned_users = Array.isArray(response.data.data) ? response.data.data.map((item) => item.assignee) : [];
    },
    fetch_users() {
      return axios.get(USER_LIST_URLS, { headers: this.headers }).then((response) => {
        const res = parse_response_data(response.data);
        this.users = res.data.map((user) => ({
          user_id: user.user_id,
          name: user.user.first_name && user.user.last_name ? `${user.user.first_name} ${user.user.last_name}` : "User has not logged in",
          email: user.user.email,
        }));
        this.users_list = this.users;
        this.user_table_headers = this.users_list.length > 0 ? Object.keys(Reflect.get(this.users_list, 0) || {}) : [];
      }).catch(() => {
        this.show_error("Error fetching users");
      });
    },
    toggle_assignment(user_id) {
      const payload = {
        project_id: this.project_id,
        user_id,
        is_assigned: !this.assigned_users.includes(user_id),
      };
      return axios.post(ASSIGN_USER_TO_PROJECT, payload, { headers: this.headers }).then(() => {
        this.assigned_users = payload.is_assigned
          ? [...this.assigned_users, user_id]
          : this.assigned_users.filter((id) => id !== user_id);
      }).catch(() => {
        this.show_error("Error fetching users");
      });
    },
    initialize_data_table() {
      this.$nextTick(() => {
        const table_element = document.getElementById("deactivated_projects_table");
        if (!table_element) return;
        const $table = $("#deactivated_projects_table");
        if ($.fn.DataTable.isDataTable("#deactivated_projects_table")) {
          $table.DataTable().destroy();
        }
        $table.DataTable({
          responsive: true,
          destroy: true,
          language: { emptyTable: "No data available in the table", info: "", lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page" },
        });
      });
    },
  },
};
